import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import App from './App';
import Categoria from './views/Categoria';
import DashBoard from './views/DashBoard';
import HistorialVenta from './views/HistorialVenta';
import Inicio from './views/Inicio';
import NotFound from './views/NotFound';
import Producto from './views/Producto';
import ReporteVenta from './views/ReporteVenta';
import Usuario from './views/Usuario';
import Venta1 from './views/Venta';
import Login from './views/Login';
import PoliticaPrivacidad from './views/PoliticaPrivacidad';
import CondicionesServicio from './views/CondicionesServicio';

import UserProvider from "./context/UserProvider"
import VerificarUsuario from './componentes/VerificarUsuario';
//CITAS
import Citas from "./views/Citas/Citas";
import ConfirmacionCita from "./views/Citas/ConfirmacionCita";
import Especialistas from "./views/Citas/Especialistas";
import ReporteCitas from "./views/Citas/ReporteCitas";
import Empresas from "./views/Administracion/Empresas";
import RPD from "./views/Administracion/Reporteria";

//DGII
import RegristroFacturaNCF from "./views/DGII/RegistroFacturaNCF";


//Consultorio
import Odontologia from "./views/Consultorio/Odontologia/Odontologia";
import Nutricion from "./views/Consultorio/Nutricion/Nutricion";
import Ginecologo from "./views/Consultorio/Ginecologo/Ginecologo";
import Gastro from "./views/Consultorio/Gastro/Gastro";
import ReportesGastro from "./views/Consultorio/Gastro/Reportes";
import ReportesGinecologo from "./views/Consultorio/Ginecologo/ImpresionReporteAtendido";
import ImpresionReceta from "./views/Consultorio/Gastro/ImpresionReceta";
import Ginecologia from "./views/Consultorio/Ginecologia/Ginecologia";
import Reclamaciones from "./views/Consultorio/Ginecologia/ReclamacionesG";
import CVentas from "./views/Consultorio/CVenta";
import Seguros from "./views/Consultorio/Seguros";
import Doctores from "./views/Consultorio/Doctores";
import Medicamentos from "./views/Consultorio/Medicamentos";
import CImpresionFactura from './views/Consultorio/CImpresionFactura';
import HistorialVentaC from './views/Consultorio/HistorialVentas';
import ReportesC from './views/Consultorio/Reportes/Reportes';
import Toxico from './views/Consultorio/Toxico';
import ImpresionReporteAtendido from './views/Consultorio/Gastro/ImpresionReporteAtendido';
import Descarga from './views/Interativo/Descargas';



//CXC
import Clientes from "./views/CXC/Cliente";
import RegistroCXC from "./views/CXC/RegistroCXC";
//Informes
import InformesCXC from './views/CXC/Informes/InformesCXC';
import ImpresionCXC from './views/CXC/Informes/ImpresionCXC';

//CXP
import RegistroCXP from "./views/cxp/RegistroCXP";
//Informes
import InformesCXP from './views/cxp/Informes/InformesInCXP';
import ImpresionCXP from './views/cxp/Informes/ImpresionCXP';



//transporte
import TPrestamo from "./views/Transporte/TPrestamo";
import Tventa from "./views/Transporte/TVenta";
import T_Clientes from "./views/Transporte/Clientes";
import Orden from './views/Transporte/Orden';
import Articulos from './views/Transporte/Articulos';
import ImpresionPrestamo from './views/Transporte/ImpresionPrestamo';
import ReporteVl from './views/Transporte/ReporteVl';

//Iglesia
import Amigos from './views/Iglesia/Amigos';
//VIPTV
import Vip from './views/Administracion/VIP';

//Prestamos
import Prestamo from './views/Prestamo/Prestamo';
import ConsultaFactura from './views/Prestamo/ConsultaFactura';


//Ventas
import Venta from './views/Ventas/Venta';
import PuntoVenta from './views/Ventas/PuntoVenta';
import HistorialVentaT from './views/Ventas/HistorialVentas';
import VentaCaja from './views/Ventas/VentaCaja';
import Articulos1 from './views/Ventas/Articulos';
import Suplidor from './views/Ventas/Suplidor';
import MovimientoAlmacen from './views/Ventas/MovimientosAlmacen';
import Almacen from './views/Ventas/Almacen';
import ImpresionFactura from './views/Ventas/ImpresionFactura';
import ImpresionCotizacion from './views/Ventas/ImpresionCotizacion';
import Clientes1 from './views/Ventas/Clientes';
import SecuenciaNumerica from './views/Administracion/SecuenciaNumerica';

import InformesInventario from './views/Inventario/Informes/InformesInventario'
import ImpresionInventario from './views/Inventario/Informes/ImpresionInventario'



//Informes
import ImpresionVentas from './views/Ventas/Informes/ImpresionVentas'

import InformesVentas from './views/Ventas/Informes/InformesVentas';
import CuadreCajaPV from './views/Ventas/Informes/CuadreCajaPV';
import CuadreCajaNCF from './views/Ventas/Informes/CuadreCajaNCF';


const root = ReactDOM.createRoot(document.getElementById('wrapper'));
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js')
            .then(reg => console.log('[SW] Registrado', reg))
            .catch(err => console.error('[SW] Error', err));
    });
}

//const v = JSON.parse(window.localStorage.getItem("sesion_usuario")).impresionPuntoVenta;
root.render(
    <BrowserRouter>
        <UserProvider>
            <Routes>

                {/*ACONTINUACION ESTABLECEMOS LAS RUTAS DE NUESTRO SISTEMA*/}
                {/*parametros*/}
                <Route index path='/ReporteVl/:ordenID/:placa' element={<VerificarUsuario> <ReporteVl /> </VerificarUsuario>} />
                <Route path='/ImpresionFactura/:Pedido' element={ <ImpresionFactura /> } />
                <Route path='/ImpresionInventario/:Pedido' element={<ImpresionInventario /> } />
                <Route path='/ImpresionVentas/:Pedido' element={<ImpresionVentas />} />
                <Route path='/ImpresionCXC/:Pedido' element={<ImpresionCXC />} />
                <Route path='/ImpresionCXP/:Pedido' element={<ImpresionCXP />} />
                <Route path='/descarga/:Pedido/:p1/:p2/:p3' element={<Descarga />} />
           
                <Route path='/CuadreCajaPV' element={<CuadreCajaPV /> } />
                <Route path='/CuadreCajaNCF' element={<CuadreCajaNCF /> } />
                <Route path='/ImpresionCotizacion/:Pedido' element={<ImpresionCotizacion /> } />
                <Route path='/CImpresionFactura/:Pedido' element={ <CImpresionFactura /> } />
                <Route path='/ImpresionReceta/:Pedido/:Reporte/:Modulo' element={<ImpresionReceta /> } />
                <Route path='/ImpresionPrestamo/:Pedido' element={<ImpresionPrestamo /> } />
                <Route path='/ImpresionReporteAtendido/:Pedido' element={<ImpresionReporteAtendido /> } />
                <Route index path='/ConfirmacionCita/:ID/:Tel' element={<ConfirmacionCita />} />

                {/*ruta individual sin usar una como base*/}
                <Route index path='/Login' element={<Login />} />
                {/*Privacidad*/}
                <Route index path='/PoliticaPrivacidad' element={<PoliticaPrivacidad />} />
                 {/*Condiciones servicio*/}
                <Route index path='/CondicionesServicio' element={<CondicionesServicio />} />

                {/*Permite anidar rutas en base a una*/}
                <Route path='/' element={<App />}>
                    {/*{*/}
                    {/*    (v == true) &&*/}
                    {/*    <Route index element={<Venta />} />*/}
                    {/*}*/}
                    {/*{*/}
                    {/*    (v == false) &&*/}
                       
                    {/*}*/}
                    <Route index element={<Inicio />} />
                    <Route path='dashboard' element={<VerificarUsuario> <DashBoard /> </VerificarUsuario>} />
                    <Route path='producto' element={<VerificarUsuario> <Producto /> </VerificarUsuario>} />
                    <Route path='categoria' element={<VerificarUsuario> <Categoria /> </VerificarUsuario>} />
                    <Route path='ventacaja' element={<VerificarUsuario> <VentaCaja /> </VerificarUsuario>} />
                    {/*<Route path='historialventa' element={<VerificarUsuario> <HistorialVenta /> </VerificarUsuario>} />*/}
                    <Route path='reporteventa' element={<VerificarUsuario > <ReporteVenta /> </VerificarUsuario>} />

                    <Route path='citas' element={<VerificarUsuario Rol="1" SubRol="1" > <Citas /> </VerificarUsuario>} />
                    <Route path='especialistas' element={<VerificarUsuario > <Especialistas /> </VerificarUsuario>} />
                    <Route path='reportecitas' element={<VerificarUsuario Rol="1" SubRol="2" > <ReporteCitas /> </VerificarUsuario>} />

                    <Route path='RegristroFacturaNCF' element={<VerificarUsuario Rol="6" SubRol="1"  > <RegristroFacturaNCF /> </VerificarUsuario>} />
                 
                    <Route path='Clientes' element={<VerificarUsuario > <Clientes /> </VerificarUsuario>} />
                    <Route path='Tventa' element={<VerificarUsuario Rol="10" SubRol="1" > <Tventa /> </VerificarUsuario>} />
                    <Route path='TPrestamo' element={<VerificarUsuario Rol="10" SubRol="2" > <TPrestamo /> </VerificarUsuario>} />
                    <Route path='T_Cliente' element={<VerificarUsuario Rol="10" SubRol="3" > <T_Clientes /> </VerificarUsuario>} />
                    <Route path='Orden' element={<VerificarUsuario Rol="10" SubRol="4" > <Orden /> </VerificarUsuario>} />
                    <Route path='Articulos' element={<VerificarUsuario Rol="10" SubRol="5" > <Articulos /> </VerificarUsuario>} />
                    <Route path='ReporteVl' element={<VerificarUsuario Rol="10" SubRol="6" > <ReporteVl /> </VerificarUsuario>} />

                    {/*Iglesia*/}

                    <Route path='Amigos' element={<VerificarUsuario> <Amigos /> </VerificarUsuario>} /> 
                    <Route path='Vip' element={<VerificarUsuario> <Vip /> </VerificarUsuario>} /> 

                    {/*Ventas*/}
                    <Route path='venta' element={<VerificarUsuario Rol="2" SubRol="1"> <Venta /> </VerificarUsuario>} />
                    <Route path='PuntoVenta' element={<VerificarUsuario Rol="2" SubRol="1"> <PuntoVenta /> </VerificarUsuario>} />
                    <Route path='HistorialVenta' element={<VerificarUsuario Rol="2" SubRol="2"> <HistorialVentaT /> </VerificarUsuario>} />
                    <Route path='InformesVentas' element={<VerificarUsuario Rol="2" SubRol="3"> <InformesVentas /> </VerificarUsuario>} />

                    {/*  Consultorio*/}
                   
      

                    {/*Inventario*/}
                    <Route path='Articulos1' element={<VerificarUsuario Rol="3" SubRol="1"> <Articulos1 /> </VerificarUsuario>} />
                    <Route path='MovimientoAlmacen' element={<VerificarUsuario Rol="3" SubRol="2"> <MovimientoAlmacen /> </VerificarUsuario>} />
                    <Route path='Almacen' element={<VerificarUsuario Rol="3" SubRol="3"> <Almacen /> </VerificarUsuario>} />
                    <Route path='InformesInventario' element={<VerificarUsuario Rol="3" SubRol="4"> <InformesInventario /> </VerificarUsuario>} />

                    {/*CXC*/}
                    <Route path='Clientes1' element={<VerificarUsuario Rol="4" SubRol="1"> <Clientes1 /> </VerificarUsuario>} />
                    <Route path='RegistroCXC' element={<VerificarUsuario Rol="4" SubRol="2" > <RegistroCXC /> </VerificarUsuario>} />
                    <Route path='InformesCXC' element={<VerificarUsuario Rol = "4" SubRol = "3"> <InformesCXC /> </VerificarUsuario>} />
                 
                    {/*CXP*/}
                    <Route path='Suplidor' element={<VerificarUsuario Rol="5" SubRol="1"> <Suplidor /> </VerificarUsuario>} />
                    <Route path='RegistroCXP' element={<VerificarUsuario Rol="5" SubRol="2" > <RegistroCXP /> </VerificarUsuario>} />
                    <Route path='InformesCXP' element={<VerificarUsuario Rol="5" SubRol="3" > <InformesCXP /> </VerificarUsuario>} />

                  {/*MEDICAL*/}

                    <Route path='Odontologia' element={<VerificarUsuario Rol="7" SubRol="1" > <Odontologia /> </VerificarUsuario>} />
                    <Route path='Gastro' element={<VerificarUsuario Rol="7" SubRol="1"> <Gastro /> </VerificarUsuario>} />
                    <Route path='Ginecologo' element={<VerificarUsuario Rol="7" SubRol="2" > <Ginecologo /> </VerificarUsuario>} />
                    <Route path='ReportesGastro' element={<VerificarUsuario Rol="7" SubRol="1" > <ReportesGastro /> </VerificarUsuario>} />
                    <Route path='ReportesGinecologo' element={<VerificarUsuario > <ReportesGinecologo /> </VerificarUsuario>} />
                    <Route path='Ginecologia' element={<VerificarUsuario > <Ginecologia /> </VerificarUsuario>} />
                    <Route path='Reclamaciones' element={<VerificarUsuario Rol="7" SubRol="3"> <Reclamaciones /> </VerificarUsuario>} />
                    <Route path='CVentas' element={<VerificarUsuario Rol="7" SubRol="3"> <CVentas /> </VerificarUsuario>} />
                    <Route path='HistorialVentaC' element={<VerificarUsuario Rol="7" SubRol="4" > <HistorialVentaC /> </VerificarUsuario>} />
                    <Route path='ReportesC' element={<VerificarUsuario Rol="7" SubRol="3"> <ReportesC /> </VerificarUsuario>} />

                    <Route path='Doctores' element={<VerificarUsuario Rol="7" SubRol="5" > <Doctores /> </VerificarUsuario>} />
                    <Route path='Seguros' element={<VerificarUsuario Rol="7" SubRol="6"> <Seguros /> </VerificarUsuario>} />
                    <Route path='Medicamentos' element={<VerificarUsuario Rol="7" SubRol="7"> <Medicamentos /> </VerificarUsuario>} />
                    <Route path='Toxico' element={<VerificarUsuario Rol="7" SubRol="8"> <Toxico /> </VerificarUsuario>} />
                    <Route path='Articulos1' element={<VerificarUsuario Rol="7" SubRol="8"> <Articulos1 /> </VerificarUsuario>} />
                    <Route path='Nutricion' element={<VerificarUsuario Rol="7" SubRol="9" > <Nutricion /> </VerificarUsuario>} />
                    <Route path='RPD' element={<VerificarUsuario > <RPD /> </VerificarUsuario>} />


                    {/*Usuario*/}
                    <Route path='usuario' element={<VerificarUsuario Rol="8" SubRol="1"> <Usuario /> </VerificarUsuario>} />
                    <Route path='empresas' element={<VerificarUsuario Rol="8" SubRol="2"> <Empresas /> </VerificarUsuario>} />
                    <Route path='secuencianumerica' element={<VerificarUsuario Rol="8" SubRol="3"> <SecuenciaNumerica /> </VerificarUsuario>} />



                    {/*PRestamo*/}
                    <Route path='Prestamo' element={<VerificarUsuario Rol="9" SubRol="1"> <Prestamo /> </VerificarUsuario>} />
                    <Route path='ConsultaFactura' element={<VerificarUsuario Rol="9" SubRol="2"> <ConsultaFactura /> </VerificarUsuario>} />
                  

                </Route>
                <Route path='*' element={<NotFound />} />
                
            </Routes>

        </UserProvider>
       

    </BrowserRouter>
);

